import { MutationTree } from 'vuex';
import { State } from './endpoints.store';
import { endpointFormMutations } from '@/components/SM/Endpoints/sm.endpoints.types';
import { initialState } from '@/store/modules/synthetics/endpoints/endpoints.store';

const mutations: MutationTree<State> = {
  setCurrentGroupID(state: State, data: any) {
    state.currentGroupId = data;
  },
  setTotalEndpointForGroups(state: State, data: any) {
    state.totalEndpointsForGroup = data;
  },
  setCurrentEndpointId(state: State, data: any) {
    state.currentEndpointId = data;
  },
  deleteEndpointId(state: State) {
    state.currentEndpointId = '';
  },
  setFormData(state: State, data: any) {
    state.formData = {
      ...state.formData,
      ...data
    };
  },
  setBasicInfoFormData(state: State, data: any) {
    if (data.type === endpointFormMutations.REPLACE_DATA) {
      state.formData.basicInfoConfig = data.payload;
    }
    if (data.type === endpointFormMutations.MODIFY_FIELDS) {
      state.formData.basicInfoConfig[data.payload.key] = data.payload.value;
    }
  },
  setAuthDetails(state: State, data: any) {
    state.formData.authConfig = {
      ...state.formData.authConfig,
      ...data
    };
  },
  setRequestDetails(state: State, data: any) {
    state.formData.requestConfig = {
      ...state.formData.requestConfig,
      ...data
    };
  },
  setAdditionalOptnDetails(state: State, data: any) {
    state.formData.additionalOptions = {
      ...state.formData.additionalOptions,
      ...data
    };
  },
  setAllMappedEndpointsDeleted(state: State, data: any) {
    state.allMappedEndpointsDeleted = data;
  },
  setDispOnlyFillDetails(state: State, data: any) {
    state.dispOnlyFillDetails = data;
  },
  setDefaultValues(state: State) {
    Object.assign(state, { ...initialState });
  },
};

export default mutations;
